<template>
  <div class="login-footer">
    <div class="login-footer-left">
      &copy; SAPICO {{ new Date().getFullYear() }}
    </div>
    <div class="login-footer-middle">
    </div>
    <div class="login-footer-right">
    </div>
    <div class="login-footer-right-max">
      <a target="_blank" href="https://sapico.pl">{{ t('login.seeMore') }}</a>

    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { t } from '@/setup/i18n-setup'

export default {
  name: 'SapicoPasswordPageFooter',
  setup() {
    return {};
  },
  data() {
    return {

    };
  },
  mounted() {

  },
  created() {

  },
  computed: {

  },
  methods: {
        t,

  },
  watch: {

  }
}
</script>
